@if (this.contract$ | async; as contract) {
  <div
    class="tab-pane fade flex-even active show h-100"
    id="claims"
    role="tabpanel"
    aria-labelledby="claims-tab"
  >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-12 col-md">
          <app-actions-group
            [actionsGroupName]="'tabView_insuranceClaims'"
            [model]="contract"
          />
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 col-md">
          <app-generic-grid
            style="height: 300px"
            [data]="contract.insuranceClaims"
            [tabViewName]="'insuranceClaims'"
          />
        </div>
      </div>
    </div>
  </div>
}
